import { FC, useId } from 'react';

export const CompetitivePrimaryBanner: FC = () => {
  const bannerId = useId();

  return (
    <div className="competitive-primary-bar" tabIndex={0} aria-describedby={bannerId}>
      <div className="candidate-detail-banner" role="tooltip" id={bannerId}>
        <p className="banner-text">
          Oath does not score or endorse candidates in competitive primaries, but you can still give
          to them if you'd like.
        </p>
      </div>
      <span className="candidate-detail-bar-text">This candidate is in a competitive primary.</span>
    </div>
  );
};
